import React from 'react';

export default class Header extends React.Component{

	render() {

		return (
			<div className="header">
				<h2>Manchester</h2>
				<h2>New York</h2>
				<h2>Vienna</h2>
			</div>
		)
	}
}